// @ts-nocheck
import { HtmlClassSwitch, DomQuery, WithClass } from "./Dom";
import { distributeEvent } from "./Event";
import { ConfirmationWindowComponent, ConfirmationClass } from "./WebApp.ConfirmationWindow";
import { FileUploadState } from "./WebApp.File_.Store";
import { application } from "./WebApp.Instance";

export class FileUploadStatusChangedEvent {
  constructor(upload) {
    this.upload = upload;
  }
}

export class UploadCenter {
  constructor() {
    this.uploads = new Map();

    this.filters = {
      successful: false,
      pending: true,
      error: true,
    };

    this.build();
    this.updateElement();

    const query = window.matchMedia('(max-width: 50em)');
    query.addEventListener(
      'change',
      (event) => {
        if (event.matches)
          this.collapsed.setStatus(true);
      }
    );

    if (query.matches)
      this.collapsed.setStatus(true);
  }

  build() {
    this.element = document.createElement("div");
    this.element.classList.add("UploadCenter");
    this.element.appendChild(this.buildToolbar());
    this.element.appendChild(this.buildTable());

    const main = document.getElementById("main");
    main.appendChild(this.element);

    this.collapsed = new HtmlClassSwitch(this.element, "Collapsed");

    // TODO: Add a proper label.
    this.confirmationWindow = new ConfirmationWindowComponent("Some uploads have failed. Are you sure you want to close all?", "Yes", "No", () => this.closeAll(), ConfirmationClass.Delete);
  }

  buildToolbar() {
    this.toolbar = document.createElement("span");
    this.toolbar.className = "Toolbar";
    this.toolbar.appendChild(this.buildTitle());
    this.toolbar.appendChild(this.buildFilterGroup());
    this.toolbar.appendChild(this.buildToggleButton());
    this.toolbar.appendChild(this.buildCloseAllButton());
    this.toolbar.appendChild(this.buildRestartAllButton());

    return this.toolbar;
  }

  buildTable() {
    this.table = document.createElement("table");
    return this.table;
  }

  buildTitle() {
    this.title = document.createElement("span");
    this.title.className = "Title";
    this.title.innerText = "Uploads";

    return this.title;
  }

  buildFilterGroup() {
    this.filterGroup = document.createElement("span");
    this.filterGroup.className = "FilterGroup";

    this.successFilter = document.createElement("button");
    this.successFilter.className = "Filter Successful";
    this.successFilter.addEventListener(
      "click",
      () => {
        this.filters.successful = !this.filters.successful;
        this.updateElement();
      }
    );

    this.pendingFilter = document.createElement("button");
    this.pendingFilter.className = "Filter Pending";
    this.pendingFilter.addEventListener(
      "click", () => {
        this.filters.pending = !this.filters.pending;
        this.updateElement();
      }
    );

    this.errorFilter = document.createElement("button");
    this.errorFilter.className = "Filter Error";
    this.errorFilter.addEventListener(
      "click", () => {
        this.filters.error = !this.filters.error;
        this.updateElement();
      }
    );

    this.filterGroup.appendChild(this.successFilter);
    this.filterGroup.appendChild(this.pendingFilter);
    this.filterGroup.appendChild(this.errorFilter);

    return this.filterGroup;
  }

  buildToggleButton() {
    this.toggleButton = document.createElement("button");
    this.toggleButton.classList = "Toggle";
    this.toggleButton.addEventListener("click", () => this.toggle());

    return this.toggleButton;
  }

  buildCloseAllButton() {
    this.closeAllButton = document.createElement("button");
    this.closeAllButton.classList = "Close";
    this.closeAllButton.addEventListener(
      "click",
      () => {
        if (this.shouldConfirmClose())
          this.confirmationWindow.show();
        else
          this.closeAll();
      }
    );

    return this.closeAllButton;
  }

  buildRestartAllButton() {
    this.restartAllButton = document.createElement("button");
    this.restartAllButton.classList = "Restart";
    this.restartAllButton.addEventListener("click", () => this.restartAll());

    return this.restartAllButton;
  }

  updateElement() {
    this.updateFilters();
    this.updateTitle();
    this.updateState();
  }

  updateFilters() {
    this.element.classList.toggle("HideSuccessful", !this.filters.successful);
    this.element.classList.toggle("HidePending", !this.filters.pending);
    this.element.classList.toggle("HideError", !this.filters.error);

    this.successFilter.classList.toggle("Off", !this.filters.successful);
    this.pendingFilter.classList.toggle("Off", !this.filters.pending);
    this.errorFilter.classList.toggle("Off", !this.filters.error);

    const uploads = Array.from(this.uploads.values());
    const counts = {
      successful: uploads.filter(upload => upload.state === FileUploadState.Submitted).length,
      pending: uploads.filter(upload => upload.state === FileUploadState.Initial || upload.state === FileUploadState.Preparing || upload.state === FileUploadState.Prepared || upload.state === FileUploadState.Uploading || upload.state === FileUploadState.Successful || upload.state === FileUploadState.Submitting).length,
      error: uploads.filter(upload => upload.state === FileUploadState.Error || upload.state === FileUploadState.Forbidden).length,
    };

    this.successFilter.textContent = `Successful ${counts.successful}`;
    this.pendingFilter.textContent = `Pending ${counts.pending}`;
    this.errorFilter.textContent = `Error ${counts.error}`;
  }

  updateTitle() {
    const query = new DomQuery(this.table);

    const total = this.table.rows.length - query.getDescendants(WithClass("Aborted")).length - query.getDescendants(WithClass("Forbidden")).length;
    const count = query.getDescendants(WithClass("Submitted")).length;

    // TODO: Use proper translated caption.
    if (total === 0)
      this.title.innerText = "Uploads";
    else
      this.title.innerText = "Uploads: " + count + " / " + total;
  }

  createRow(upload) {
    const row = this.table.insertRow();
    row.className = FileUploadState.toText(upload.state);
    row.dataset.Id = upload.id;

    let cell = row.insertCell();
    cell.classList.add("Name");
    cell.appendChild(document.createTextNode(upload.name));

    cell = row.insertCell();
    cell.classList.add("Target");
    cell.appendChild(document.createTextNode(upload.target));

    cell = row.insertCell();
    cell.classList.add("Size")
    cell.appendChild(document.createTextNode((upload.size / 1000000).toFixed(2) + "MB"));

    const imageCell = row.insertCell();
    imageCell.classList.add("Thumbnail");

    this.renderThumbnail(upload, imageCell);

    const progress = document.createElement("span");
    progress.style.width = 100 * upload.progress + "%";

    const container = document.createElement("span");
    container.appendChild(progress);

    cell = row.insertCell();
    cell.classList.add("Progress");
    cell.appendChild(container);

    cell = row.insertCell();
    cell.classList.add("Actions");

    let action = document.createElement("button");
    action.className = "Abort";
    action.addEventListener("click", () => this.abortUpload(upload.id));

    cell.appendChild(action);

    action = document.createElement("button");
    action.className = "Restart";
    action.addEventListener("click", () => this.restartUpload(upload.id));

    cell.appendChild(action);

    cell = row.insertCell();
    cell.classList.add("Problems");

    this.renderProblems(upload, cell);
  }

  getRow(id) {
    return new DomQuery(this.table).getDescendant((element) => element.dataset.Id == id);
  }

  deleteRow(id) {
    this.uploads.delete(id);
    const row = this.getRow(id);

    if (row) {
      const index = Array.from(this.table.rows).indexOf(row);

      if (index !== -1)
        this.table.deleteRow(index);
    }
  }

  renderProblems(upload, target) {
    if (!Array.isArray(upload.problems))
      upload.problems = [upload.problems]

    target.innerHTML = "";

    upload.problems.forEach(
      (problemJson) => {
        let problem = document.createElement("span");
        problem.innerText = problemJson.Message;
        problem.classList.add("Problem");

        if ("Severity" in problemJson)
          problem.classList.add(problemJson.Severity.replace(/\s/g, ""));

        target.appendChild(problem);
      }
    );
  }

  renderThumbnail(upload, target) {
    application.fileStore.getThumbnail(upload.id)
      .then(
        (file) => {
          if (file.thumbnail) {
            const image = document.createElement("img");
            image.src = URL.createObjectURL(new Blob([file.thumbnail]));
            image.title = file.name;

            target.innerHTML = "";
            target.appendChild(image);
          }
        }
      );
  }

  updateRow(upload) {
    let row = this.getRow(upload.id);
    const query = new DomQuery(row);

    const target = query.getChild(WithClass("Target"));
    target.innerText = upload.target;

    const progress = query.getChild(WithClass("Progress"));
    progress.childNodes[0].childNodes[0].style.width = 100 * upload.progress + "%";

    const thumbnail = query.getChild(WithClass("Thumbnail"));

    if (thumbnail.childNodes.length === 0)
      this.renderThumbnail(upload, thumbnail);

    const problems = query.getChild(WithClass("Problems"));
    this.renderProblems(upload, problems);

    row.className = FileUploadState.toText(upload.state);
  }

  async abortUpload(id) {
    // TODO: This operation should happen in a single transaction.
    const file = await application.fileStore.get(parseInt(id));
    file.state = FileUploadState.Aborted;

    await application.fileStore.update(file);
    this.serviceWorker.controller.postMessage(file);
  }

  async restartUpload(id) {
    // TODO: This operation should happen in a single transaction.
    const file = await application.fileStore.get(parseInt(id));

    if (file.location !== null) {
      file.state = FileUploadState.Prepared;
      file.progress = 0.05;
      file.problems = [];
    }
    else {
      file.state = FileUploadState.Initial;
      file.progress = 0;
      file.problems = [];
    }

    await application.fileStore.update(file);
    this.serviceWorker.controller.postMessage(file);
  }

  updateState() {
    if (this.table.rows.length == 0)
      this.element.classList.remove("Expanded");
    else {
      if (this.isActive()) {
        this.element.classList.add("Active");
        this.element.classList.add("Expanded");
      }
      else
        this.element.classList.remove("Active");

      const query = new DomQuery(this.element);
      const closeButton = query.getDescendant(WithClass("Close"));

      if (closeButton) {
        if (this.isClosable())
          closeButton.removeAttribute("disabled");
        else
          closeButton.setAttribute("disabled", "true");
      }

      const restartButton = query.getDescendant(WithClass("Restart"));

      if (restartButton) {
        if (this.isRestartable())
          restartButton.removeAttribute("disabled");
        else
          restartButton.setAttribute("disabled", "true");
      }
    }
  }

  isActive() {
    const completedUploads = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Submitted || upload.state === FileUploadState.Aborted), 0);
    return this.uploads.size > completedUploads;
  }

  isClosable() {
    const finishedUploads = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Submitted || upload.state === FileUploadState.Error || upload.state === FileUploadState.Aborted), 0);
    return this.uploads.size === finishedUploads;
  }

  isRestartable() {
    const errors = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Error), 0);
    return errors > 0;
  }

  shouldConfirmClose() {
    const errors = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Error), 0);
    return errors > 0;
  }

  restartAll() {
    this.uploads.values().forEach(
      (upload) => {
        if (upload.state === FileUploadState.Error)
          this.restartUpload(upload.id);
      }
    );
  }

  closeAll() {
    this.uploads.values().forEach(
      (upload) => {
        if (upload.state === FileUploadState.Error)
          this.abortUpload(upload.id);

        this.deleteRow(upload.id);
      }
    );

    this.updateState();
  }

  toggle() {
    this.collapsed.toggle();
  }

  reload(upload) {
    if (this.uploads.has(upload.id)) {
      this.uploads.set(upload.id, upload);

      let row = this.getRow(upload.id);
      row.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });

      this.updateRow(upload);
      this.updateElement();

      distributeEvent(new FileUploadStatusChangedEvent(upload));
    }
  }

  reloadAll(uploads) {
    for (const upload of uploads) {
      if (this.uploads.has(upload.id))
        this.updateRow(upload);
      else
        this.createRow(upload)

      this.uploads.set(upload.id, upload);
    }

    this.updateElement();
  }

  connect(serviceWorker) {
    if (this.listener !== undefined)
      this.serviceWorker.removeEventListener("message", this.listener);

    this.listener = (event) => {
      const data = event.data;

      if (event.data.class === "Files") {
        if (Array.isArray(data.value))
          this.reloadAll(data.value);
        else
          this.reload(data.value);
      }

      this.updateState();
    }

    this.serviceWorker = serviceWorker;
    this.serviceWorker.addEventListener("message", this.listener);
  }
}
